jQuery(document).ready(function ($) {
    const eatAndDrink = new Swiper('.eat-and-drink__pages', {
        loop: false,

        slidesPerView: 1,
        slidesPerGroup: 1,

        longSwipes: false,

        spaceBetween: 80,

        grabCursor: true,

        autoplay: false,

        pagination: {
            el: '.eat-and-drink__pages--pagination',
            type: 'bullets',
            bulletClass: 'pagination__bullet',
            bulletActiveClass: 'active',
            clickable: true
        },

        breakpoints: {
            480: {
                slidesPerView: 2,
                slidesPerGroup: 1,
            },
            1024: {
                slidesPerView: 3,
                slidesPerGroup: 3,

                grabCursor: false
            }
        }
    });
});